export const filters = {
  branches: true,
  month: true,
  year: true,
};
